import { render, staticRenderFns } from "./suggestedPost.vue?vue&type=template&id=4241675e&"
import script from "./suggestedPost.vue?vue&type=script&lang=js&"
export * from "./suggestedPost.vue?vue&type=script&lang=js&"
import style0 from "./suggestedPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports